import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/vue-logo.png'
import _imports_1 from '../../../../assets/github-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-017ce6b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-dark navbar-expand" }
const _hoisted_2 = { class: "container navbar-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "vue",
  className: "vue-image d-none d-md-block"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/nothingnothings/VueDex",
  rel: "noreferrer",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "github-source-code",
    className: "github-image d-none d-sm-block"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationItems = _resolveComponent("NavigationItems")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NavigationItems),
      _hoisted_3,
      _hoisted_4
    ])
  ]))
}